<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">
            ข้อมูล Branch Keyword
          </h1>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-row v-if="isLoadingData">
          <b-col class="px-4 px-sm-5 py-4 vh-100">
            <img src="/img/loading.svg" class="loading" alt="loading" />
          </b-col>
        </b-row>
        <div>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="Main Keyword"
                placeholder="Main Keyword"
                type="text"
                name="mainKeyword"
                isRequired
                v-model="form.mainKeyword"
                :isValidate="$v.form.mainKeyword.$error"
                :v="$v.form.mainKeyword"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Roboflow Class Name"
                placeholder="roboflowClassName"
                type="text"
                name="lastname"
                v-model="form.roboflowClassName"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <!-- <InputText
                textFloat="Prompt Template Id"
                placeholder="Prompt Template Id"
                type="number"
                name="promptTemplateId"
                isRequired
                v-model="form.promptTemplateId"
                :isValidate="$v.form.promptTemplateId.$error"
                :v="$v.form.promptTemplateId"
              /> -->
              <b-form-group class="mb-0" label="Prompt Template Id">
                <select
                  class="custom-select"
                  v-model="form.promptTemplateId"
                  :id="'promptTemplateId'"
                >
                  <option :value="0">เลือก</option>
                  <option
                    v-for="prompt in listPrompt"
                    :key="prompt.id"
                    :value="prompt.id"
                  >
                    {{ prompt.name }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Fuzzy Score Precent (%)"
                placeholder="Fuzzy Score Precent"
                type="number"
                name="fuzzyScorePrecent"
                isRequired
                v-model="form.fuzzyScorePrecent"
                :isValidate="$v.form.fuzzyScorePrecent.$error"
                :v="$v.form.fuzzyScorePrecent"
              />
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                มีเลข Invoice
                <span class="text-danger">*</span>
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isHaveInvoiceNo"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isHaveInvoiceNo ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col>
              <label class="font-weight-bold main-label">
                สถานะ
                <span class="text-danger">*</span>
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isActive"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isActive ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>

            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsUsePriceFromSumProduct
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isUsePriceFromSumProduct"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isUsePriceFromSumProduct ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsMergeProductNameAndCode
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isMergeProductNameAndCode"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isMergeProductNameAndCode ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsMergeProductNameMultipleLines
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isMergeProductNameMultipleLines"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isMergeProductNameMultipleLines ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsGetProductFromGPT
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isGetProductFromGPT"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isGetProductFromGPT ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="InvoiceNoRegexPattern"
                placeholder="InvoiceNoRegexPattern"
                type="text"
                name="invoiceNoRegexPattern"
                v-model="form.invoiceNoRegexPattern"
              />
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsUseAllProducts
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isUseAllProducts"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isUseAllProducts ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsDiscountAllProducts
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isDiscountAllProducts"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isDiscountAllProducts ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsDiscountProductsFromNextItem
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isDiscountProductsFromNextItem"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isDiscountProductsFromNextItem ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
            <b-col md="6">
              <label class="font-weight-bold main-label">
                IsAlwaysSetQuantityOne
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.isAlwaysSetQuantityOne"
                  class="radio-active"
                  size="lg"
                  value="1"
                  unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    form.isAlwaysSetQuantityOne ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <div>
                <b-input-group class="mb-2">
                  <b-form-input
                    v-model="newTag"
                    placeholder="New tag - Press enter to add"
                    class="form-control"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button @click="addTag()" variant="primary">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
                <div class="d-inline-block" style="font-size: 1.5rem">
                  <b-form-tag
                    v-for="(tag, idx) in form.branchAlternativeKeywords"
                    @remove="removeTag(tag, idx)"
                    :key="idx"
                    :title="tag.keyword"
                    class="mr-1"
                  >
                    {{ tag.keyword }}
                  </b-form-tag>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col md="6">
              <b-button
                :disabled="isDisable"
                @click="cancleHandler"
                class="btn-details-set btn-cancel"
                >CANCEL</b-button
              >
            </b-col>
            <b-col md="6" class="text-sm-right">
              <button
                type="button"
                @click="checkForm()"
                :disabled="isDisable"
                class="btn btn-main btn-details-set ml-md-2 text-uppercase"
              >
                SAVE
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  alphaNum
} from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);

const alpha = helpers.regex("alpha", /^[\u0E00-\u0E7Fa-zA-Z']*$/);

import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading
  },
  data() {
    return {
      isLoadingData: false,
      modalMessage: "",
      isDisable: false,
      id: this.$route.params.id,
      redirecId: 0,
      form: {
        id: 0,
        mainKeyword: "",
        roboflowClassName: "",
        promptTemplateId: 1,
        isHaveInvoiceNo: 1,
        branchAlternativeKeywords: [],
        branchIdAlternativeKeywordsDeleted: [],
        isActive: 1,
        fuzzyScorePrecent: 100,
        isUsePriceFromSumProduct: 0,
        isMergeProductNameAndCode: 0,
        isMergeProductNameMultipleLines: 0,
        isGetProductFromGPT: 0,
        invoiceNoRegexPattern: "",
        isUseAllProducts: 0,
        isDiscountAllProducts: 0,
        isDiscountProductsFromNextItem: 0,
        isAlwaysSetQuantityOne: 0
      },
      newTag: "",
      listPrompt: []
    };
  },
  validations: {
    form: {
      mainKeyword: { required },
      promptTemplateId: { required, alphaNum },
      fuzzyScorePrecent: { required, alphaNum }
      // username: { required },
      // staffId: { required, alphaNum },
      // password: {
      //   required: requiredIf(function () {
      //     return this.id == 0;
      //   }),
      //   password,
      //   minLength: minLength(8)
      // }
    }
  },
  created: async function () {
    this.getDatas();
    this.getListPrompt();
  },
  methods: {
    isAlphabet: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 65 && charCode < 91) {
        return true;
      } else if (charCode > 96 && charCode < 123) {
        return true;
      } else if (charCode > 160 && charCode < 238) {
        return true;
      } else {
        evt.preventDefault();
      }
      // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      //   evt.preventDefault();
      // } else {
      //   return true;
      // }
    },
    hadleModalAlertClose() {
      this.$router.push({
        path: `/branch-keyword`
      });
    },
    cancleHandler() {
      this.$router.push({ name: "Branch Keyword" });
    },
    getDatas: async function () {
      if (this.id !== "0") {
        this.isLoadingData = true;
        await this.axios
          .get(`${this.$baseUrl}/branchkeyword/${this.id}`)
          .then(res => {
            if (res.data.result == 1) {
              this.form = { ...this.form, ...res.data.detail };
              this.isLoadingData = false;
            }
          });
      } else {
      }
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/branchkeyword`, this.form)
        .then(res => {
          if (res.data.result == 1) {
            this.redirecId = res.data.detail.id;
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = res.data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    },
    addTag() {
      if (this.newTag.trim() !== "") {
        const newTag = {
          id: 0,
          branchMainKeywordId: parseInt(this.$route.params.id),
          keyword: this.newTag.trim()
        };
        this.form.branchAlternativeKeywords.push(newTag);
        this.newTag = ""; // Clear the input field after adding the tag
      }
    },
    removeTag(tagToRemove, idx) {
      if (tagToRemove.id) {
        this.form.branchIdAlternativeKeywordsDeleted.push(tagToRemove.id);
      }
      this.form.branchAlternativeKeywords.splice(idx, 1);
    },
    getListPrompt: async function () {
      await this.axios
        .get(
          `${this.$baseUrl}/promptTemplate/list?search=&page=1&perpage=200`,
          this.filter
        )
        .then(res => {
          if (res.data.result == 1) {
            this.listPrompt = res.data.detail.data;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-reset-password {
  background-color: #7160c4;
  color: white;
}
</style>
